(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(93259);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/media-query/use-breakpoint-value.mjs + 3 modules
var use_breakpoint_value = __webpack_require__(21757);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/flex/flex.mjs
var flex = __webpack_require__(88329);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/image/img.mjs
var img = __webpack_require__(70647);
// EXTERNAL MODULE: ./src/layout/index.tsx
var layout = __webpack_require__(81072);
// EXTERNAL MODULE: ./src/components/SEO/index.tsx
var SEO = __webpack_require__(27353);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/spinner/spinner.mjs
var spinner = __webpack_require__(48899);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/skeleton/skeleton.mjs + 1 modules
var skeleton = __webpack_require__(80678);
// EXTERNAL MODULE: ./src/components/SearchBar/FreeSearch.tsx
var FreeSearch = __webpack_require__(37986);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/hooks/Custom/index.ts + 3 modules
var Custom = __webpack_require__(65673);
// EXTERNAL MODULE: ./src/hooks/Vehicles/Enums/index.ts
var Enums = __webpack_require__(76624);
// EXTERNAL MODULE: ./src/utils/useIsMount.ts
var useIsMount = __webpack_require__(70798);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/toast/use-toast.mjs + 2 modules
var use_toast = __webpack_require__(6459);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(68029);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(90092);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(73636);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/button/button.mjs + 4 modules
var button_button = __webpack_require__(38491);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Select2/index.tsx
var Select2 = __webpack_require__(74594);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/utils/index.ts + 9 modules
var utils = __webpack_require__(91558);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/popover/popover.mjs + 68 modules
var popover = __webpack_require__(18042);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/popover/popover-trigger.mjs + 1 modules
var popover_trigger = __webpack_require__(49130);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/image/image.mjs + 1 modules
var image_image = __webpack_require__(42811);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/popover/popover-content.mjs + 1 modules
var popover_content = __webpack_require__(73898);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/popover/popover-body.mjs
var popover_body = __webpack_require__(43803);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/input/input.mjs
var input = __webpack_require__(82206);
;// CONCATENATED MODULE: ./src/components/Select2/indexmobile.tsx






function Select2Mobile(_param) {
    var handleClose = function handleClose() {
        setIsOpen(false);
    };
    var typeInput = _param.typeInput, customW = _param.customW, Border = _param.Border, OptionsData = _param.OptionsData, Selected = _param.Selected, Default = _param.Default, HasImg = _param.HasImg, setSelected = _param.setSelected, Callback = _param.Callback, Placeholder = _param.Placeholder, Trigger = _param.Trigger, HasNullOption = _param.HasNullOption, IsLast = _param.IsLast, Submiter = _param.Submiter, Skew = _param.Skew, SkewAngle = _param.SkewAngle, PopAdjust = _param.PopAdjust, MarginR = _param.MarginR, ScrollAdj = _param.ScrollAdj, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "typeInput",
        "customW",
        "Border",
        "OptionsData",
        "Selected",
        "Default",
        "HasImg",
        "setSelected",
        "Callback",
        "Placeholder",
        "Trigger",
        "HasNullOption",
        "IsLast",
        "Submiter",
        "Skew",
        "SkewAngle",
        "PopAdjust",
        "MarginR",
        "ScrollAdj"
    ]);
    var ref;
    var ref1 = (0,react.useState)(false), IsOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(""), Filter = ref2[0], setFilter = ref2[1];
    var InputRef = (0,react.useRef)(null);
    var OptionRef = (0,react.useRef)(null);
    var PopoverRef = (0,react.useRef)(null);
    var SearchInputRef = (0,react.useRef)(null);
    (0,Custom/* useIsomorphicLayoutEffect */.LI)(function() {
        if (Boolean(Trigger)) {
            console.log("Trigger", Trigger);
            setIsOpen(true);
        }
    }, [
        Trigger
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        w: customW,
        border: "1px solid",
        borderColor: "ll-gray.100",
        bgColor: "ll-gray.600",
        borderRadius: "50px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
            position: "relative",
            w: "full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                    w: "full",
                    h: "48px",
                    alignItems: "center",
                    justifyContent: "space-between"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                    position: "absolute",
                    top: "10px",
                    left: "0px",
                    w: "100%",
                    h: "40px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
                        matchWidth: true,
                        initialFocusRef: SearchInputRef,
                        placement: "bottom-end",
                        onClose: function() {
                            setIsOpen(false);
                            setFilter("");
                        },
                        closeOnBlur: true,
                        isOpen: IsOpen,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_trigger/* PopoverTrigger */.x, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                    as: "button",
                                    p: 1,
                                    type: "button",
                                    cursor: "pointer",
                                    justifyContent: "space-between",
                                    pl: "15px",
                                    alignItems: "center",
                                    onClick: function() {
                                        return setIsOpen(function(prev) {
                                            return !prev;
                                        });
                                    },
                                    w: "full",
                                    h: "30px",
                                    children: [
                                        HasImg && /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                            w: Selected ? "40px" : "35px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                                onError: function(e) {
                                                    return e.currentTarget.src = "https://cdn.pneufree.com.br/CMS/carros/TOYOTA.png";
                                                },
                                                src: Selected ? (0,utils/* vehicleImagePath */.j6)("".concat(Selected)) : (0,utils/* vehicleImagePath */.j6)(Default),
                                                width: "40px",
                                                height: "40px",
                                                alt: "Fabricante"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                            cursor: "pointer",
                                            _focus: {
                                                border: "none"
                                            },
                                            fontSize: "text1",
                                            children: Selected !== null && Selected !== void 0 ? Selected : Placeholder
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                            justifyContent: "center",
                                            alignItems: "center",
                                            minW: "28px",
                                            minH: "28px",
                                            bgColor: "ll-gray.100",
                                            borderRadius: "50px",
                                            mr: "5px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                                                w: "12px",
                                                src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow.svg"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_content/* PopoverContent */.y, {
                                bg: "white",
                                borderRadius: "25px",
                                style: {
                                    boxShadow: "#0000002e 2px 5px 10px"
                                },
                                py: "5px",
                                borderColor: "ll-gray.600",
                                w: "full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_body/* PopoverBody */.b, {
                                    w: "full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                            focusBorderColor: "ll-gray.300",
                                            borderColor: "ll-gray.200",
                                            borderRadius: "25px",
                                            type: typeInput,
                                            w: "full",
                                            maxH: rest.w && "25px",
                                            mb: "5px",
                                            p: "10px",
                                            placeholder: "Busque..",
                                            value: Filter,
                                            ref: SearchInputRef,
                                            onKeyDown: function(e) {
                                                if (e.key === "Enter") {
                                                    var ref;
                                                    OptionRef === null || OptionRef === void 0 ? void 0 : (ref = OptionRef.current) === null || ref === void 0 ? void 0 : ref.click();
                                                }
                                            },
                                            onChange: function(e) {
                                                return setFilter(e.target.value.toLowerCase());
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                            direction: "column",
                                            overflowY: "scroll",
                                            overflowX: "hidden",
                                            className: "Select2",
                                            maxH: "300px",
                                            w: ScrollAdj ? [
                                                "full",
                                                "140%"
                                            ] : null,
                                            ml: ScrollAdj ? [
                                                "0px",
                                                "-3px"
                                            ] : null,
                                            children: [
                                                HasNullOption && /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                                    py: "5px",
                                                    onClick: function() {
                                                        setSelected(null);
                                                        if (Callback) {
                                                            Callback(null);
                                                        }
                                                        if (IsLast) {
                                                            setIsOpen(false);
                                                            Submiter(null);
                                                        }
                                                    },
                                                    _hover: {
                                                        bg: "blue.100"
                                                    },
                                                    bg: Selected === null ? "blue.100" : "white",
                                                    cursor: "pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                        ml: "10px",
                                                        children: Placeholder !== null && Placeholder !== void 0 ? Placeholder : "TODOS"
                                                    })
                                                }),
                                                (ref = OptionsData.filter(function(s) {
                                                    if (Filter.length > 0) {
                                                        return s.value.toLowerCase().includes(Filter);
                                                    } else {
                                                        return true;
                                                    }
                                                })) === null || ref === void 0 ? void 0 : ref.map(function(opt, key) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                                        ref: key === 0 ? OptionRef : PopoverRef,
                                                        py: "5px",
                                                        id: opt.value,
                                                        onClick: function() {
                                                            setSelected(opt.value);
                                                            if (Callback) {
                                                                Callback(opt.value);
                                                            }
                                                            if (IsLast) {
                                                                setIsOpen(false);
                                                                Submiter(opt.value);
                                                            }
                                                        },
                                                        _hover: {
                                                            bg: "blue.100"
                                                        },
                                                        bg: Selected === opt.value ? "blue.100" : "white",
                                                        cursor: "pointer",
                                                        children: [
                                                            HasImg && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                                                src: (0,utils/* vehicleImagePath */.j6)("".concat(opt.label)),
                                                                alt: "".concat(opt.label),
                                                                loading: "lazy",
                                                                mr: "5px",
                                                                w: "20px",
                                                                h: "20px"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                                children: opt.label
                                                            })
                                                        ]
                                                    }, key);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/SearchBar/SizeSearch.tsx












function SizeSearchDesktop(param) {
    var loading = param.loading, loadingAnim = param.loadingAnim;
    // ! Env Data
    var DefaultWidth = "185";
    var DefaultSeries = "65";
    var DefaultRim = "15";
    // ! Initial States
    var ref = (0,react.useState)([]), Widths = ref[0], setWidths = ref[1];
    var ref1 = (0,react.useState)(DefaultWidth), SelectedWidth = ref1[0], setSelectedWidth = ref1[1];
    var ref2 = (0,react.useState)([]), Series = ref2[0], setSeries = ref2[1];
    var ref3 = (0,react.useState)(DefaultSeries), SelectedSeries = ref3[0], setSelectedSeries = ref3[1];
    var ref4 = (0,react.useState)([]), Rims = ref4[0], setRims = ref4[1];
    var ref5 = (0,react.useState)(DefaultRim), SelectedRim = ref5[0], setSelectedRim = ref5[1];
    // ! Controllers & Rullers
    var ref6 = (0,react.useState)(0), SeriesTrigger = ref6[0], setSeriesTrigger = ref6[1];
    var ref7 = (0,react.useState)(0), RimTrigger = ref7[0], setRimTrigger = ref7[1];
    var IsFirstMount = (0,useIsMount/* useIsMount */.z)();
    var Toast = (0,use_toast/* useToast */.p)({
        position: "bottom",
        duration: 3000,
        isClosable: true
    });
    var Router = (0,router.useRouter)();
    var isWideVersion = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: true
    });
    function requestWidths() {
        return _requestWidths.apply(this, arguments);
    }
    function _requestWidths() {
        _requestWidths = // ! Methods
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, WData, WError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncWidths */.er)()
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), WData = ref[0], WError = ref[1];
                        if (WData && WError === null) {
                            setWidths(WData === null || WData === void 0 ? void 0 : WData.map(function(w) {
                                return {
                                    label: w,
                                    value: w
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestWidths.apply(this, arguments);
    }
    function requestSeries(Width) {
        return _requestSeries.apply(this, arguments);
    }
    function _requestSeries() {
        _requestSeries = (0,_async_to_generator/* default */.Z)(function(Width) {
            var ref, SData, SError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncSeries */.Uq)(Width)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), SData = ref[0], SError = ref[1];
                        if (SData && SError === null) {
                            setSeries(SData.map(function(s) {
                                return {
                                    label: s,
                                    value: s
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestSeries.apply(this, arguments);
    }
    function requestRims(Width, Series) {
        return _requestRims.apply(this, arguments);
    }
    function _requestRims() {
        _requestRims = (0,_async_to_generator/* default */.Z)(function(Width, Series) {
            var ref, RData, RError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncRims */.IQ)(Width, Series)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), RData = ref[0], RError = ref[1];
                        if (RData && RError === null) {
                            setRims(RData === null || RData === void 0 ? void 0 : RData.map(function(r) {
                                return {
                                    label: r,
                                    value: r
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestRims.apply(this, arguments);
    }
    function submitSizeSearch(e) {
        return _submitSizeSearch.apply(this, arguments);
    }
    function _submitSizeSearch() {
        _submitSizeSearch = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!SelectedWidth) {
                    Toast({
                        title: "Selecione uma largura para realizar a pesquisa por medida.",
                        status: "info",
                        containerStyle: {
                            color: "white",
                            fontFamily: "arial",
                            fontWeight: "100"
                        }
                    });
                } else if (!SelectedRim && !e) {
                    Toast({
                        title: "Selecione um aro para realizar a pesquisa por medida.",
                        status: "info",
                        containerStyle: {
                            color: "white",
                            fontFamily: "arial",
                            fontWeight: "100"
                        }
                    });
                } else {
                    loadingAnim(true);
                    ;
                    Router.push({
                        pathname: "/pesquisa/medida",
                        query: {
                            width: "".concat(SelectedWidth),
                            series: "".concat(SelectedSeries),
                            rim: "".concat((ref = SelectedRim !== null && SelectedRim !== void 0 ? SelectedRim : e) !== null && ref !== void 0 ? ref : "")
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return _submitSizeSearch.apply(this, arguments);
    }
    // ! Effects
    (0,Custom/* useIsomorphicLayoutEffect */.LI)(function() {
        requestWidths();
        requestSeries(DefaultWidth);
        requestRims(DefaultWidth, DefaultSeries);
    }, []);
    // ! Main return
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                textStyle: "Regular",
                color: "ll-gray.500",
                mb: "8px",
                children: "Busque pela medida:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(h_stack/* HStack */.U, {
                spacing: "13px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* Select2 */.u, {
                        customW: "105px",
                        width: "110px",
                        OptionsData: Widths,
                        setSelected: setSelectedWidth,
                        Selected: SelectedWidth,
                        Skew: false,
                        Callback: function(e) {
                            setSelectedSeries(null);
                            setSelectedRim(null);
                            requestSeries(e);
                            setSeriesTrigger(function(prev) {
                                return prev + 1;
                            });
                        },
                        ScrollAdj: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* Select2 */.u, {
                        customW: "105px",
                        MarginR: "-3px",
                        w: "85px",
                        OptionsData: Series,
                        setSelected: setSelectedSeries,
                        Selected: SelectedSeries,
                        Skew: false,
                        Trigger: SeriesTrigger,
                        Callback: function(e) {
                            setSelectedRim(null);
                            requestRims(SelectedWidth, e);
                            setRimTrigger(function(prev) {
                                return prev + 1;
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* Select2 */.u, {
                        customW: "105px",
                        MarginR: "-3px",
                        w: "85px",
                        OptionsData: Rims,
                        setSelected: setSelectedRim,
                        Selected: SelectedRim,
                        Trigger: RimTrigger,
                        IsLast: true,
                        Skew: false,
                        Submiter: submitSizeSearch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        width: "100px",
                        variant: "primary-button",
                        bgColor: "ll-blue.main",
                        _hover: {
                            opacity: "0.5"
                        },
                        onClick: function() {
                            return submitSizeSearch(null);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                            children: "Buscar"
                        })
                    })
                ]
            })
        ]
    });
}
function SizeSearchMobile(param) {
    var loading = param.loading, loadingAnim = param.loadingAnim;
    // ! Env Data
    var DefaultWidth = "185";
    var DefaultSeries = "65";
    var DefaultRim = "15";
    var isWideVersion = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: true
    });
    // ! Initial States
    var ref = (0,react.useState)([]), Widths = ref[0], setWidths = ref[1];
    var ref1 = (0,react.useState)(DefaultWidth), SelectedWidth = ref1[0], setSelectedWidth = ref1[1];
    var ref2 = (0,react.useState)([]), Series = ref2[0], setSeries = ref2[1];
    var ref3 = (0,react.useState)(DefaultSeries), SelectedSeries = ref3[0], setSelectedSeries = ref3[1];
    var ref4 = (0,react.useState)([]), Rims = ref4[0], setRims = ref4[1];
    var ref5 = (0,react.useState)(DefaultRim), SelectedRim = ref5[0], setSelectedRim = ref5[1];
    // ! Controllers & Rullers
    var ref6 = (0,react.useState)(0), SeriesTrigger = ref6[0], setSeriesTrigger = ref6[1];
    var ref7 = (0,react.useState)(0), RimTrigger = ref7[0], setRimTrigger = ref7[1];
    var IsFirstMount = (0,useIsMount/* useIsMount */.z)();
    var Toast = (0,use_toast/* useToast */.p)({
        position: "bottom",
        duration: 3000,
        isClosable: true
    });
    var Router = (0,router.useRouter)();
    function requestWidths() {
        return _requestWidths.apply(this, arguments);
    }
    function _requestWidths() {
        _requestWidths = // ! Methods
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, WData, WError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncWidths */.er)()
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), WData = ref[0], WError = ref[1];
                        if (WData && WError === null) {
                            setWidths(WData === null || WData === void 0 ? void 0 : WData.map(function(w) {
                                return {
                                    label: w,
                                    value: w
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestWidths.apply(this, arguments);
    }
    function requestSeries(Width) {
        return _requestSeries.apply(this, arguments);
    }
    function _requestSeries() {
        _requestSeries = (0,_async_to_generator/* default */.Z)(function(Width) {
            var ref, SData, SError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncSeries */.Uq)(Width)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), SData = ref[0], SError = ref[1];
                        if (SData && SError === null) {
                            setSeries(SData.map(function(s) {
                                return {
                                    label: s,
                                    value: s
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestSeries.apply(this, arguments);
    }
    function requestRims(Width, Series) {
        return _requestRims.apply(this, arguments);
    }
    function _requestRims() {
        _requestRims = (0,_async_to_generator/* default */.Z)(function(Width, Series) {
            var ref, RData, RError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncRims */.IQ)(Width, Series)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), RData = ref[0], RError = ref[1];
                        if (RData && RError === null) {
                            setRims(RData === null || RData === void 0 ? void 0 : RData.map(function(r) {
                                return {
                                    label: r,
                                    value: r
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestRims.apply(this, arguments);
    }
    function submitSizeSearch() {
        return _submitSizeSearch.apply(this, arguments);
    }
    function _submitSizeSearch() {
        _submitSizeSearch = (0,_async_to_generator/* default */.Z)(function() {
            var e, ref;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                if (!SelectedWidth) {
                    Toast({
                        title: "Selecione uma largura para realizar a pesquisa por medida.",
                        status: "info",
                        containerStyle: {
                            color: "white",
                            fontFamily: "arial",
                            fontWeight: "100"
                        }
                    });
                } else if (!SelectedSeries) {
                    Toast({
                        title: "Selecione uma altura para realizar a pesquisa por medida.",
                        status: "info",
                        containerStyle: {
                            color: "white",
                            fontFamily: "arial",
                            fontWeight: "100"
                        }
                    });
                } else if (!SelectedRim && !e) {
                    Toast({
                        title: "Selecione um aro para realizar a pesquisa por medida.",
                        status: "info",
                        containerStyle: {
                            color: "white",
                            fontFamily: "arial",
                            fontWeight: "100"
                        }
                    });
                } else {
                    loadingAnim(true);
                    ;
                    Router.push({
                        pathname: "/pesquisa/medida",
                        query: {
                            width: "".concat(SelectedWidth),
                            series: "".concat(SelectedSeries),
                            rim: "".concat((ref = SelectedRim !== null && SelectedRim !== void 0 ? SelectedRim : e) !== null && ref !== void 0 ? ref : "")
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return _submitSizeSearch.apply(this, arguments);
    }
    // ! Effects
    (0,Custom/* useIsomorphicLayoutEffect */.LI)(function() {
        requestWidths();
        requestSeries(DefaultWidth);
        requestRims(DefaultWidth, DefaultSeries);
    }, []);
    // ! Main return
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                h: "auto",
                w: "full",
                alignItems: "center",
                justifyContent: "center",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        justifyContent: "flex-start",
                        w: "full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                            color: "#58585A",
                            textStyle: "Regular",
                            mb: "10px",
                            children: "Busque pela medida"
                        })
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        w: "full",
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                w: "calc(100%/3)",
                                height: "40px",
                                borderRadius: "50px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                w: "calc(100%/3)",
                                height: "40px",
                                borderRadius: "50px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                w: "calc(100%/3)",
                                height: "40px",
                                borderRadius: "50px"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(h_stack/* HStack */.U, {
                        w: "full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2Mobile, {
                                typeInput: "number",
                                MarginR: "0px",
                                customW: "calc(100%/3)",
                                OptionsData: Widths,
                                setSelected: setSelectedWidth,
                                Selected: SelectedWidth,
                                Skew: false,
                                Callback: function(e) {
                                    setSelectedSeries(null);
                                    setSelectedRim(null);
                                    requestSeries(e);
                                    setSeriesTrigger(function(prev) {
                                        return prev + 1;
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2Mobile, {
                                typeInput: "number",
                                MarginR: "0px",
                                customW: "calc(100%/3)",
                                OptionsData: Series,
                                setSelected: setSelectedSeries,
                                Selected: SelectedSeries,
                                Trigger: SeriesTrigger,
                                Skew: false,
                                Callback: function(e) {
                                    setSelectedRim(null);
                                    requestRims(SelectedWidth, e);
                                    setRimTrigger(function(prev) {
                                        return prev + 1;
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2Mobile, {
                                typeInput: "number",
                                MarginR: "0px",
                                customW: "calc(100%/3)",
                                OptionsData: Rims,
                                setSelected: setSelectedRim,
                                Selected: SelectedRim,
                                Trigger: RimTrigger,
                                Skew: false,
                                IsLast: true,
                                Submiter: submitSizeSearch
                            })
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                mt: "10px",
                w: "full",
                height: "40px",
                borderRadius: "50px"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                variant: "primary-button",
                bgColor: "ll-blue.main",
                mt: "1rem",
                w: "full",
                type: "submit",
                "aria-label": "Pesquisar",
                onClick: function() {
                    return submitSizeSearch();
                },
                children: "Buscar"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-KRPLQIP4.mjs
var chunk_KRPLQIP4 = __webpack_require__(93717);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs + 4 modules
var chunk_2OOHT3W5 = __webpack_require__(26900);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-ZHMYA64R.mjs + 4 modules
var chunk_ZHMYA64R = __webpack_require__(2291);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-3ASUQ6PA.mjs
var chunk_3ASUQ6PA = __webpack_require__(34292);
;// CONCATENATED MODULE: ./src/components/SearchBar/VehicleSearch.tsx












function VehicleSearchDesktop(param) {
    var loading = param.loading, loadingAnim = param.loadingAnim;
    // ! Env Data
    var DefaultBrand = "VOLKSWAGEN";
    var DefaultModel = "POLO";
    var DefaultYear = "2023";
    // ! Initial States
    var ref = (0,react.useState)([]), Brands = ref[0], setBrands = ref[1];
    var ref1 = (0,react.useState)(DefaultBrand), SelectedBrand = ref1[0], setSelectedBrand = ref1[1];
    var ref2 = (0,react.useState)([]), Models = ref2[0], setModels = ref2[1];
    var ref3 = (0,react.useState)(DefaultModel), SelectedModel = ref3[0], setSelectedModel = ref3[1];
    var ref4 = (0,react.useState)([]), Years = ref4[0], setYears = ref4[1];
    var ref5 = (0,react.useState)(DefaultYear), SelectedYear = ref5[0], setSelectedYear = ref5[1];
    // ! Controllers & Rullers
    var ref6 = (0,react.useState)(0), ModelTrigger = ref6[0], setModelTrigger = ref6[1];
    var ref7 = (0,react.useState)(0), YearTrigger = ref7[0], setYearTrigger = ref7[1];
    var Toast = (0,use_toast/* useToast */.p)({
        position: "bottom",
        duration: 3000,
        isClosable: true
    });
    var Router = (0,router.useRouter)();
    function requestBrands() {
        return _requestBrands.apply(this, arguments);
    }
    function _requestBrands() {
        _requestBrands = // ! Methods
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, BData, BError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncBrands */.Fr)()
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), BData = ref[0], BError = ref[1];
                        if (BData && BError === null) {
                            setBrands(BData === null || BData === void 0 ? void 0 : BData.map(function(brand) {
                                return {
                                    label: brand,
                                    value: brand
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestBrands.apply(this, arguments);
    }
    function requestModels(Brand) {
        return _requestModels.apply(this, arguments);
    }
    function _requestModels() {
        _requestModels = (0,_async_to_generator/* default */.Z)(function(Brand) {
            var ref, MData, MError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncModelsByBrand */.o0)(Brand)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), MData = ref[0], MError = ref[1];
                        if (MData && MError === null) {
                            setModels(MData === null || MData === void 0 ? void 0 : MData.map(function(model) {
                                return {
                                    label: model,
                                    value: model
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestModels.apply(this, arguments);
    }
    function requestYears(Brand, Model) {
        return _requestYears.apply(this, arguments);
    }
    function _requestYears() {
        _requestYears = (0,_async_to_generator/* default */.Z)(function(Brand, Model) {
            var ref, YData, YError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncYearsByModelBrand */.vJ)(Brand, Model)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), YData = ref[0], YError = ref[1];
                        if (YData && YError === null) {
                            setYears(YData === null || YData === void 0 ? void 0 : YData.map(function(comp) {
                                return {
                                    label: comp.year,
                                    value: comp.year
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestYears.apply(this, arguments);
    }
    function submitVehicleSearch() {
        return _submitVehicleSearch.apply(this, arguments);
    }
    function _submitVehicleSearch() {
        _submitVehicleSearch = (0,_async_to_generator/* default */.Z)(function() {
            var e, ref;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                Toast.closeAll();
                switch(true){
                    case !Boolean(SelectedBrand):
                        Toast({
                            title: "Selecione uma marca para realizar a pesquisa.",
                            status: "info"
                        });
                        return [
                            2,
                            false
                        ];
                    case !Boolean(SelectedModel):
                        Toast({
                            title: "Selecione um modelo para realizar a pesquisa.",
                            status: "info"
                        });
                        return [
                            2,
                            false
                        ];
                    default:
                        loadingAnim(true);
                        ;
                        Router.push({
                            pathname: "/pesquisa/veiculo",
                            query: Boolean(e) ? {
                                brand: "".concat(SelectedBrand),
                                model: "".concat(SelectedModel),
                                year: "".concat((ref = SelectedYear !== null && SelectedYear !== void 0 ? SelectedYear : e) !== null && ref !== void 0 ? ref : "")
                            } : {
                                brand: "".concat(SelectedBrand),
                                model: "".concat(SelectedModel)
                            }
                        });
                }
                return [
                    2
                ];
            });
        });
        return _submitVehicleSearch.apply(this, arguments);
    }
    // ! Effects
    (0,Custom/* useIsomorphicLayoutEffect */.LI)(function() {
        requestBrands();
        requestModels(DefaultBrand);
        requestYears(DefaultBrand, DefaultModel);
    }, []);
    var isWideVersion = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: true,
        lg: false,
        xl: true
    });
    var array = [
        "blue",
        "pink",
        "red"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_KRPLQIP4/* Flex */.k, {
            w: "full",
            flexDir: "column",
            alignItems: "flex-start",
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
                w: "full",
                h: "40px",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                        w: "280px",
                        height: "40px",
                        borderRadius: "50px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                        w: "200px",
                        height: "40px",
                        borderRadius: "50px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                        w: "200px",
                        height: "40px",
                        borderRadius: "50px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                        w: "100px",
                        height: "40px",
                        borderRadius: "520px"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                        textStyle: "Regular",
                        color: "#58585A",
                        ml: isWideVersion ? "0px" : "6.2rem",
                        mb: "8px",
                        mt: "1rem",
                        children: "Busque por ve\xedculo:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
                        w: "full",
                        h: "40px",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
                                w: "full",
                                justifyContent: "space-between",
                                mr: "10px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* Select2 */.u, {
                                        customW: "280px",
                                        OptionsData: Brands,
                                        setSelected: setSelectedBrand,
                                        Selected: SelectedBrand,
                                        Skew: false,
                                        HasImg: true,
                                        Callback: function(e) {
                                            setSelectedModel(null);
                                            setSelectedYear(null);
                                            requestModels(e);
                                            setModelTrigger(function(prev) {
                                                return prev + 1;
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* Select2 */.u, {
                                        customW: "200px",
                                        Skew: true,
                                        OptionsData: Models,
                                        setSelected: setSelectedModel,
                                        Selected: SelectedModel,
                                        Trigger: ModelTrigger,
                                        Callback: function(e) {
                                            setSelectedYear(null);
                                            requestYears(SelectedBrand, e);
                                            setYearTrigger(function(prev) {
                                                return prev + 1;
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* Select2 */.u, {
                                        customW: "200px",
                                        Skew: false,
                                        OptionsData: Years,
                                        setSelected: setSelectedYear,
                                        Selected: SelectedYear,
                                        Trigger: YearTrigger,
                                        HasNullOption: true,
                                        Callback: function(e) {
                                            setSelectedYear(e);
                                        },
                                        IsLast: true,
                                        Submiter: submitVehicleSearch
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                variant: "primary-button",
                                bgColor: "ll-blue.main",
                                onClick: submitVehicleSearch,
                                minW: "100px",
                                _hover: {
                                    opacity: "0.5"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                                    textStyle: "Regular",
                                    color: "white",
                                    children: "Buscar"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function VehicleSearchMobile(param) {
    var loading = param.loading, loadingAnim = param.loadingAnim;
    // ! Env Data
    var DefaultBrand = "VOLKSWAGEN";
    var DefaultModel = "POLO";
    var DefaultYear = "2023";
    // ! Initial States
    var ref = (0,react.useState)([]), Brands = ref[0], setBrands = ref[1];
    var ref1 = (0,react.useState)(DefaultBrand), SelectedBrand = ref1[0], setSelectedBrand = ref1[1];
    var ref2 = (0,react.useState)([]), Models = ref2[0], setModels = ref2[1];
    var ref3 = (0,react.useState)(DefaultModel), SelectedModel = ref3[0], setSelectedModel = ref3[1];
    var ref4 = (0,react.useState)([]), Years = ref4[0], setYears = ref4[1];
    var ref5 = (0,react.useState)(DefaultYear), SelectedYear = ref5[0], setSelectedYear = ref5[1];
    // ! Controllers & Rullers
    var ref6 = (0,react.useState)(0), ModelTrigger = ref6[0], setModelTrigger = ref6[1];
    var ref7 = (0,react.useState)(0), YearTrigger = ref7[0], setYearTrigger = ref7[1];
    var Toast = (0,use_toast/* useToast */.p)({
        position: "bottom",
        duration: 3000,
        isClosable: true
    });
    var Router = (0,router.useRouter)();
    function requestBrands() {
        return _requestBrands.apply(this, arguments);
    }
    function _requestBrands() {
        _requestBrands = // ! Methods
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, BData, BError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncBrands */.Fr)()
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), BData = ref[0], BError = ref[1];
                        if (BData && BError === null) {
                            setBrands(BData === null || BData === void 0 ? void 0 : BData.map(function(brand) {
                                return {
                                    label: brand,
                                    value: brand
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestBrands.apply(this, arguments);
    }
    function requestModels(Brand) {
        return _requestModels.apply(this, arguments);
    }
    function _requestModels() {
        _requestModels = (0,_async_to_generator/* default */.Z)(function(Brand) {
            var ref, MData, MError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncModelsByBrand */.o0)(Brand)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), MData = ref[0], MError = ref[1];
                        if (MData && MError === null) {
                            setModels(MData === null || MData === void 0 ? void 0 : MData.map(function(model) {
                                return {
                                    label: model,
                                    value: model
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestModels.apply(this, arguments);
    }
    function requestYears(Brand, Model) {
        return _requestYears.apply(this, arguments);
    }
    function _requestYears() {
        _requestYears = (0,_async_to_generator/* default */.Z)(function(Brand, Model) {
            var ref, YData, YError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,Enums/* useAsyncYearsByModelBrand */.vJ)(Brand, Model)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), YData = ref[0], YError = ref[1];
                        if (YData && YError === null) {
                            setYears(YData === null || YData === void 0 ? void 0 : YData.map(function(comp) {
                                return {
                                    label: comp.year,
                                    value: comp.year
                                };
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _requestYears.apply(this, arguments);
    }
    function submitVehicleSearch() {
        return _submitVehicleSearch.apply(this, arguments);
    }
    function _submitVehicleSearch() {
        _submitVehicleSearch = (0,_async_to_generator/* default */.Z)(function() {
            var e, ref;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                Toast.closeAll();
                switch(true){
                    case !Boolean(SelectedBrand):
                        Toast({
                            title: "Selecione uma marca para realizar a pesquisa.",
                            status: "info"
                        });
                        return [
                            2,
                            false
                        ];
                    case !Boolean(SelectedModel):
                        Toast({
                            title: "Selecione um modelo para realizar a pesquisa.",
                            status: "info"
                        });
                        return [
                            2,
                            false
                        ];
                    default:
                        loadingAnim(true);
                        ;
                        Router.push({
                            pathname: "/pesquisa/veiculo",
                            query: Boolean(e) ? {
                                brand: "".concat(SelectedBrand),
                                model: "".concat(SelectedModel),
                                year: "".concat((ref = SelectedYear !== null && SelectedYear !== void 0 ? SelectedYear : e) !== null && ref !== void 0 ? ref : "")
                            } : {
                                brand: "".concat(SelectedBrand),
                                model: "".concat(SelectedModel)
                            }
                        });
                }
                return [
                    2
                ];
            });
        });
        return _submitVehicleSearch.apply(this, arguments);
    }
    // ! Effects
    (0,Custom/* useIsomorphicLayoutEffect */.LI)(function() {
        requestBrands();
        requestModels(DefaultBrand);
        requestYears(DefaultBrand, DefaultModel);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
                alignItems: "center",
                w: "full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_KRPLQIP4/* Flex */.k, {
                        justifyContent: "flex-start",
                        w: "full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                            textStyle: "Regular",
                            color: "#58585A",
                            children: "Busque pelo seu ve\xedculo:"
                        })
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                        w: "full",
                        height: "40px",
                        borderRadius: "50px"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2Mobile, {
                        customW: "100%",
                        OptionsData: Brands,
                        setSelected: setSelectedBrand,
                        Selected: SelectedBrand,
                        Skew: false,
                        HasImg: true,
                        Callback: function(e) {
                            setSelectedModel(null);
                            setSelectedYear(null);
                            requestModels(e);
                            setModelTrigger(function(prev) {
                                return prev + 1;
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_3ASUQ6PA/* HStack */.U, {
                        w: "full",
                        mt: "10px",
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                    w: "calc(100%/2)",
                                    height: "40px",
                                    borderRadius: "50px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                    w: "calc(100%/2)",
                                    height: "40px",
                                    borderRadius: "50px"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2Mobile, {
                                    customW: "calc(100%/2)",
                                    Skew: true,
                                    OptionsData: Models,
                                    setSelected: setSelectedModel,
                                    Selected: SelectedModel,
                                    Trigger: ModelTrigger,
                                    Callback: function(e) {
                                        setSelectedYear(null);
                                        requestYears(SelectedBrand, e);
                                        setYearTrigger(function(prev) {
                                            return prev + 1;
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2Mobile, {
                                    typeInput: "number",
                                    customW: "calc(100%/2)",
                                    Skew: false,
                                    OptionsData: Years,
                                    setSelected: setSelectedYear,
                                    Selected: SelectedYear,
                                    Trigger: YearTrigger,
                                    HasNullOption: true,
                                    Callback: function(e) {
                                        setSelectedYear(e);
                                    },
                                    IsLast: true,
                                    Submiter: submitVehicleSearch
                                })
                            ]
                        })
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                mt: "1rem",
                w: "full",
                height: "40px",
                borderRadius: "50px"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                variant: "primary-button",
                bgColor: "ll-blue.main",
                mt: "1rem",
                w: "full",
                "aria-label": "Pesquisar",
                onClick: submitVehicleSearch,
                children: "Buscar"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/SearchBar/SearchBar.tsx






function SearchBar(param) {
    var loading = param.loading;
    var loadingToogle = function loadingToogle() {
        setLoadingSearch(true);
    };
    var isWide = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: false
    });
    var ref = (0,react.useState)(false), loadingSearch = ref[0], setLoadingSearch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
        display: [
            "none",
            "Flex"
        ],
        w: "full",
        h: "auto",
        minH: "235px",
        justifyContent: "center",
        alignItems: "center",
        bgColor: "ll-white.main",
        borderBottom: "2px solid #E3E3E3",
        mt: "-5px",
        mb: "25px",
        children: [
            loadingSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                w: "full",
                h: "220px",
                position: "absolute",
                zIndex: 2,
                bgColor: "#ffffff8c",
                justifyContent: "center",
                alignItems: "center",
                cursor: "wait",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                    thickness: "4px",
                    speed: "0.65s",
                    emptyColor: "gray.200",
                    color: "blue.500",
                    size: "xl"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                zIndex: 1,
                w: "865px",
                flexDir: "column",
                padding: "25px",
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        w: "full",
                        justifyContent: "flex-end",
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                    mr: "5px",
                                    w: "50%",
                                    height: "65px",
                                    borderRadius: "30px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                    ml: "5px",
                                    w: "50%",
                                    height: "65px",
                                    borderRadius: "30px"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeSearch/* FreeSearchDesktop */.yT, {
                                    loadingAnim: loadingToogle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeSearchDesktop, {
                                    loadingAnim: loadingToogle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        w: "full",
                        borderTop: "1px dashed #e9e9e9",
                        mt: "20px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleSearchDesktop, {
                        loading: loading,
                        loadingAnim: loadingToogle
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/SearchBar/SearchBarMobile.tsx






function SearchBarMobile(param) {
    var loading = param.loading;
    var loadingToogleSize = function loadingToogleSize() {
        setLoadingSearchSize(true);
    };
    var loadingToogleSizeVehicle = function loadingToogleSizeVehicle() {
        setLoadingSearchSizeVehicle(true);
    };
    var ref = (0,react.useState)(false), loadingSearchSize = ref[0], setLoadingSearchSize = ref[1];
    var ref1 = (0,react.useState)(false), loadingSearchVehicle = ref1[0], setLoadingSearchSizeVehicle = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
            display: [
                "Flex",
                "none"
            ],
            w: "full",
            h: "full",
            direction: "column",
            px: "10px",
            mt: "10px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
                    mb: "1rem",
                    p: "1rem",
                    direction: "column",
                    bgColor: "ll-white.main",
                    align: "center",
                    justify: "start",
                    w: "full",
                    h: "full",
                    borderRadius: "5px",
                    border: "1px solid",
                    borderColor: "ll-gray.100",
                    children: [
                        loadingSearchSize && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_KRPLQIP4/* Flex */.k, {
                            w: "full",
                            h: "140px",
                            position: "absolute",
                            zIndex: 2,
                            bgColor: "#ffffff8c",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "wait",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                                thickness: "4px",
                                speed: "0.65s",
                                emptyColor: "gray.200",
                                color: "blue.500",
                                size: "xl"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeSearchMobile, {
                            loading: loading,
                            loadingAnim: loadingToogleSize
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
                    p: "1rem",
                    direction: "column",
                    bgColor: "ll-white.main",
                    align: "center",
                    justify: "start",
                    w: "full",
                    h: "full",
                    borderRadius: "5px",
                    border: "1px solid",
                    borderColor: "ll-gray.100",
                    children: [
                        loadingSearchVehicle && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_KRPLQIP4/* Flex */.k, {
                            w: "full",
                            h: "220px",
                            position: "absolute",
                            zIndex: 2,
                            bgColor: "#ffffff8c",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "wait",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                                thickness: "4px",
                                speed: "0.65s",
                                emptyColor: "gray.200",
                                color: "blue.500",
                                size: "xl"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleSearchMobile, {
                            loading: loading,
                            loadingAnim: loadingToogleSizeVehicle
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/SearchBar/SearchButton.tsx





function SearchButton(_param) {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({
        borderRadius: "3px",
        as: "label",
        flex: "1",
        paddingY: "4",
        paddingX: "8",
        marginLeft: "6",
        alignSelf: "center",
        alignItems: "center",
        color: "gray.200",
        position: "relative",
        justify: "center",
        bg: "yellow.900",
        maxWidth: "80px",
        w: "50px",
        h: [
            "36px",
            "48px"
        ],
        // transform="skew(-20deg)"
        _hover: {
            opacity: "0.9"
        }
    }, rest), {
        children: children
    }));
}

;// CONCATENATED MODULE: ./src/components/SearchBar/index.ts




// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/link/link.mjs
var link_link = __webpack_require__(57879);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/center/center.mjs
var center = __webpack_require__(15715);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/components/Rating/index.tsx
var components_Rating = __webpack_require__(84016);
// EXTERNAL MODULE: ./src/contexts/LoadingContext.tsx
var LoadingContext = __webpack_require__(28544);
// EXTERNAL MODULE: ./src/hooks/Contents/index.ts + 6 modules
var Contents = __webpack_require__(29557);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
;// CONCATENATED MODULE: ./src/components/Carousel/CarouselProducts.tsx













function CarouselProducts(param) {
    var title = param.title, color = param.color, loading = param.loading, display = param.display;
    var ArrowProductsPrev = function ArrowProductsPrev(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                position: "absolute",
                left: "-2%",
                top: "50%",
                zIndex: 1,
                onClick: onClick,
                cursor: "pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                    src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-slide.svg"
                })
            })
        });
    };
    var ArrowProductsNext = function ArrowProductsNext(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                position: "absolute",
                right: "-2%",
                top: "50%",
                zIndex: 1,
                onClick: onClick,
                cursor: "pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                    src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-slide.svg",
                    transform: "rotate(-180deg)"
                })
            })
        });
    };
    var isWide = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: false
    });
    var setActionIsLoading = (0,LoadingContext/* useLoading */.r$)().setActionIsLoading;
    var ref = (0,react.useState)(null), ListProducts = ref[0], setListProducts = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Contents/* useCarouselContents */.jL)(), 3), CarouselResponse = ref1[0], CarouselError = ref1[1], CarouselLoading = ref1[2];
    (0,react.useEffect)(function() {
        if (CarouselResponse && CarouselError === null) {
            var ref;
            setListProducts(CarouselResponse === null || CarouselResponse === void 0 ? void 0 : (ref = CarouselResponse[0]) === null || ref === void 0 ? void 0 : ref.contentsArray);
        }
    }, [
        CarouselResponse
    ]);
    var settings = {
        arrows: true,
        dots: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        centerMode: false,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsNext, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsPrev, {}),
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrow: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    var renderSlides = function() {
        return ListProducts.map(function(slide, index) {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                minH: "435px",
                w: '{["full", "300px"]}',
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                    w: [
                        "full",
                        "230px"
                    ],
                    h: "435px",
                    mr: "10px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                        w: "full",
                        height: "full",
                        borderRadius: "10px"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                    justify: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "https://www.pneufree.com.br/linglong/".concat(slide.Url),
                        _hover: {
                            textDecoration: "none",
                            opacity: "0.7"
                        },
                        _focus: {
                            border: "none"
                        },
                        mb: "15px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                            position: "relative",
                            w: [
                                "full",
                                "230px"
                            ],
                            h: "435px",
                            direction: "column",
                            alignItems: "center",
                            bg: "white",
                            border: "1px solid",
                            borderColor: "gray.100",
                            borderRadius: "10px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                w: "90%",
                                direction: "column",
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.x, {
                                        h: "190px",
                                        marginBottom: "95px",
                                        marginTop: "5px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                                loading: "lazy",
                                                borderTopRadius: "6px",
                                                src: (0,utils/* shoppingImagePath */.ph)(slide.Img),
                                                alt: slide.Model,
                                                width: "205px",
                                                height: "205px",
                                                onError: function(e) {
                                                    return e.currentTarget.src = "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/pneu-default.png";
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                mt: "5px",
                                                justifyContent: "center",
                                                align: "center",
                                                fontSize: "h2",
                                                color: "ll-gray.300",
                                                fontWeight: "600",
                                                letterSpacing: "-1px",
                                                lineHeight: "28px",
                                                children: slide.Title
                                            }),
                                            slide.Model.includes("RUN FLAT") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                                gap: "5px",
                                                w: "full",
                                                justifyContent: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                        align: "center",
                                                        fontWeight: "500",
                                                        fontSize: "text1",
                                                        color: "ll-blue.main",
                                                        children: slide.Model.split(" ", 1)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* Text */.x, {
                                                        align: "center",
                                                        fontWeight: "500",
                                                        fontSize: "text1",
                                                        color: "ll-red.main",
                                                        children: [
                                                            " ",
                                                            "RUN FLAT"
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                align: "center",
                                                fontWeight: "500",
                                                fontSize: "text1",
                                                color: "ll-blue.main",
                                                children: (ref1 = (ref = slide.Model) === null || ref === void 0 ? void 0 : ref.replace(slide.Title, "")) === null || ref1 === void 0 ? void 0 : ref1.replace("PNEU", "").replace("LINGLONG", "")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Rating/* Rating */.iG, {
                                            number: false,
                                            generalGrade: slide.Ratings,
                                            reviewCount: slide.Reviews
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                        mt: "5px",
                                        alignItems: "baseline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                fontSize: "h1",
                                                color: "ll-blue.main",
                                                fontWeight: "500",
                                                letterSpacing: "-3px",
                                                children: (0,utils/* formatPrice */.T4)(parseFloat(slide.Price))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                ml: "5px",
                                                color: "ll-gray.300",
                                                fontSize: "14px",
                                                fontWeight: "400",
                                                children: "\xe0 vista."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        variant: "primary-button",
                                        w: "full",
                                        mt: "10px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                            children: "DETALHES"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.x, {
        display: [
            "none",
            "Flex"
        ],
        flexDir: "column",
        h: "auto",
        minH: "435px",
        maxW: isWide ? "1000px" : "1200",
        w: "full",
        justifyContent: "center",
        mb: "2.5rem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(center/* Center */.M, {
                color: "ll-blue.main",
                fontSize: "21px",
                letterSpacing: "10px",
                fontWeight: "500",
                mb: "15px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, settings), {
                children: ListProducts ? renderSlides() : null
            }))
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(58868);
;// CONCATENATED MODULE: ./src/components/Carousel/CarouselHeader.tsx













function CarouselHeader() {
    var ArrowProductsPrev = function ArrowProductsPrev(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            cursor: "pointer",
            bgColor: "#ffffff26",
            borderRadius: "50px",
            justifyContent: "center",
            alignItems: "center",
            w: "45px",
            h: "45px",
            position: "absolute",
            left: "15%",
            top: "45%",
            zIndex: 1,
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                h: "15px",
                src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-banner.svg"
            })
        });
    };
    var ArrowProductsNext = function ArrowProductsNext(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            cursor: "pointer",
            bgColor: "#ffffff26",
            borderRadius: "50px",
            justifyContent: "center",
            alignItems: "center",
            w: "45px",
            h: "45px",
            position: "absolute",
            right: "15%",
            top: "45%",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                h: "15px",
                src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-banner.svg",
                transform: "rotate(180deg)"
            })
        });
    };
    var ref = (0,react.useState)(true), isLoading = ref[0], setLoading = ref[1];
    var IsWide = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        lg: true
    });
    var setActionIsLoading = (0,LoadingContext/* useLoading */.r$)().setActionIsLoading;
    var ref1 = (0,react.useState)([]), ListCarousel = ref1[0], setListCarousel = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,Contents/* useBannersContents */.eI)(), 3), BannersResponse = ref2[0], BannersError = ref2[1], BannersLoading = ref2[2];
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function() {
        if (BannersResponse && BannersError === null) {
            var ref;
            setListCarousel(BannersResponse === null || BannersResponse === void 0 ? void 0 : (ref = BannersResponse[0]) === null || ref === void 0 ? void 0 : ref.contentsArray);
            // setListCarousel(null);
            setLoading(false);
        }
    }, [
        BannersResponse
    ]);
    var settings = {
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 4500,
        adaptiveHeight: false,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsNext, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsPrev, {})
    };
    var isWideVersion = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
        minH: "200px",
        display: [
            "none",
            "Flex"
        ],
        flexDir: "column",
        w: "auto",
        justifyContent: "center",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            w: "full",
            h: [
                "100px",
                "250px"
            ],
            alignItems: "center",
            justify: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                thickness: "3px",
                speed: "0.65s",
                emptyColor: "ll-green.main",
                color: "#1e1e1e",
                size: [
                    "md",
                    "xl"
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, settings), {
                children: [
                    (ListCarousel === null || ListCarousel === void 0 ? void 0 : ListCarousel.length) > 0 ? ListCarousel.map(function(slide, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                href: slide.Url,
                                onClickCapture: function() {
                                    return setActionIsLoading(true);
                                },
                                onClick: function() {
                                    router_default().push(slide.Url);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                    border: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                            marginRight: "-2px",
                                            border: "none",
                                            w: "full",
                                            h: [
                                                "90px",
                                                "auto"
                                            ],
                                            background: slide.BgLeft,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            display: [
                                                "none",
                                                "flex"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                            loading: index > 0 ? "lazy" : "eager",
                                            src: isWideVersion ? slide.Image : slide.MobileImage,
                                            alt: "Banner LingLong",
                                            width: [
                                                "full",
                                                "1180px"
                                            ],
                                            height: [
                                                "auto",
                                                "230px"
                                            ],
                                            onError: function(e) {
                                                return e.currentTarget.src = "https://cdn.pneufree.com.br/LINGLONG/images/Site/img/local/DefaultBanner.jpg";
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                            marginLeft: "-2px",
                                            border: "none",
                                            w: "full",
                                            background: slide.BgRight,
                                            alignItems: "center",
                                            display: [
                                                "none",
                                                "flex"
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, index);
                    }) : null,
                    ListCarousel === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        border: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                            border: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                    border: "none",
                                    w: "100vw",
                                    h: [
                                        "120px",
                                        "auto"
                                    ],
                                    background: "#106BBA",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                    loading: "eager",
                                    alt: "Default Banner LingLong",
                                    src: "https://cdn.pneufree.com.br/LINGLONG/images/Site/img/local/DefaultBanner.jpg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                    border: "none",
                                    w: "100vw",
                                    background: "#014B96",
                                    alignItems: "center"
                                })
                            ]
                        })
                    }) : null
                ]
            }))
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./src/components/Carousel/CarouselPromo.tsx











function ArrowProductsPrev(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineDoubleArrow */.Zwx, {
        className: className,
        fill: "red",
        style: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), {
            display: "block",
            margin: " 0",
            color: "#0766c7 !important",
            transform: "rotateY(180deg) translateY(-10px)"
        }),
        onClick: onClick,
        color: "#0766c7"
    });
}
function ArrowProductsNext(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineDoubleArrow */.Zwx, {
        fill: "red",
        className: className,
        style: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), {
            display: "block",
            margin: "0",
            color: "#0766c7 !important"
        }),
        onClick: onClick,
        color: "#0766c7"
    });
}
function CarouselPromo() {
    var isWideVersion = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: true,
        md: false,
        lg: false,
        xl: true
    });
    var ref = (0,react.useState)(null), ListPromo = ref[0], setListPromo = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Contents/* useStoriesContents */.WA)(), 3), PromoData = ref1[0], PromoError = ref1[1], PromoLoading = ref1[2];
    (0,Custom/* useIsomorphicLayoutEffect */.LI)(function() {
        if (PromoData) {
            var ref;
            setListPromo(PromoData === null || PromoData === void 0 ? void 0 : (ref = PromoData[0]) === null || ref === void 0 ? void 0 : ref.contentsArray);
        }
    }, [
        PromoData
    ]);
    var settings = {
        arrows: true,
        dots: true,
        slidesToShow: 4,
        autoplay: false,
        infinite: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        centerMode: false,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsNext, {
            id: "NextArrow"
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsPrev, {
            id: "PrevArrow"
        }),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    var renderSlides = function() {
        return ListPromo.map(function(slide, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                w: "calc(100%/3)",
                href: slide.Url,
                transition: ".5s",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                    w: "full",
                    borderRadius: "5px",
                    loading: "lazy",
                    "aria-hidden": "true",
                    src: slide.Image,
                    alt: slide.Alt
                }, index)
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            w: "1200px",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                w: "full",
                gap: 5,
                justifyContent: "space-between",
                children: ListPromo ? renderSlides() : null
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Carousel/CarouselProductsRelease.tsx










function CarouselProductsRelease_ArrowProductsPrev(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ _jsx(MdOutlineDoubleArrow, {
        className: className,
        style: _object_spread_props(_object_spread({}, style), {
            display: "block",
            margin: " 0",
            color: "#0766c7 !important",
            transform: "rotateY(180deg) translateY(-10px)"
        }),
        onClick: onClick
    });
}
function CarouselProductsRelease_ArrowProductsNext(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ _jsx(MdDoubleArrow, {
        className: className,
        style: _object_spread_props(_object_spread({}, style), {
            display: "block",
            margin: "0",
            color: "#0766c7 !important"
        }),
        onClick: onClick
    });
}
function CarouselProductsRelease(param) {
    var title = param.title, color = param.color;
    var ref = useState([]), ListProducts = ref[0], setListProducts = ref[1];
    var settings = {
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        infinite: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        centerMode: false,
        nextArrow: /*#__PURE__*/ _jsx(CarouselProductsRelease_ArrowProductsNext, {}),
        prevArrow: /*#__PURE__*/ _jsx(CarouselProductsRelease_ArrowProductsPrev, {}),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrow: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    var renderSlides = function() {
        return ListProducts.map(function(slide, index) {
            return /*#__PURE__*/ _jsx(Flex, {
                h: "full",
                w: [
                    "full",
                    "320px"
                ],
                mt: [
                    "0",
                    "20px"
                ],
                children: /*#__PURE__*/ _jsx(Flex, {
                    justify: "center",
                    children: /*#__PURE__*/ _jsx(Link, {
                        _hover: {
                            textDecoration: "none"
                        },
                        width: "100%",
                        mb: "15px",
                        //passHref
                        href: null,
                        onClick: function() {
                            Router.push("https://www.pneufree.com.br/linglong/".concat(slide.url));
                        },
                        _focus: {
                            boxShadow: "none"
                        },
                        children: /*#__PURE__*/ _jsxs(Flex, {
                            w: [
                                "full",
                                "380px"
                            ],
                            h: "220px",
                            direction: "row",
                            justify: "center",
                            alignItems: "center",
                            bg: "white",
                            border: "1px solid",
                            mb: "0",
                            borderColor: "gray.100",
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    src: slide.img,
                                    alt: slide.model,
                                    loading: "lazy",
                                    w: "140px",
                                    alignItems: "center"
                                }),
                                /*#__PURE__*/ _jsxs(Flex, {
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            textStyle: "MRegular",
                                            fontSize: "text1",
                                            color: "gray.700",
                                            children: "PNEU"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            fontSize: [
                                                "h4",
                                                "h3"
                                            ],
                                            color: "gray.700",
                                            textStyle: "MBold",
                                            children: slide.title
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            textStyle: "MBold",
                                            fontSize: "text1",
                                            color: "blue.900",
                                            children: slide.model
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            children: /*#__PURE__*/ _jsx(Rating, {
                                                generalGrade: slide.rating,
                                                reviewCount: slide.reviews
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            my: "16px",
                                            fontSize: "text3",
                                            textStyle: "MBold",
                                            colorScheme: "green",
                                            w: [
                                                "130px",
                                                "180px"
                                            ],
                                            h: "30px",
                                            borderRadius: "0",
                                            _focus: {
                                                border: "none"
                                            },
                                            children: "VER DETALHES"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }, index);
        });
    };
    return /*#__PURE__*/ _jsx(_Fragment, {});
}

;// CONCATENATED MODULE: ./src/components/Carousel/index.ts





;// CONCATENATED MODULE: ./src/components/Carousel/CarouselProductsMobile.tsx














function CarouselProductsMobile(param) {
    var title = param.title, color = param.color, loading = param.loading, display = param.display;
    var ArrowProductsPrev = function ArrowProductsPrev(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isWide && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineDoubleArrow */.Zwx, {
                className: className,
                fill: "#FF003A",
                style: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), {
                    display: "block",
                    margin: " 0",
                    color: "#0766c7 !important",
                    transform: "rotateY(180deg) translateY(-10px)"
                }),
                onClick: onClick
            })
        });
    };
    var ArrowProductsNext = function ArrowProductsNext(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isWide && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdDoubleArrow */.m7R, {
                className: className,
                style: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), {
                    display: "block",
                    margin: "0",
                    color: "#0766c7 !important"
                }),
                fill: "#FF003A",
                onClick: onClick
            })
        });
    };
    var isWide = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: true
    });
    var setActionIsLoading = (0,LoadingContext/* useLoading */.r$)().setActionIsLoading;
    var ref = (0,react.useState)(null), ListProducts = ref[0], setListProducts = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Contents/* useCarouselContents */.jL)(), 3), CarouselResponse = ref1[0], CarouselError = ref1[1], CarouselLoading = ref1[2];
    (0,react.useEffect)(function() {
        if (CarouselResponse && CarouselError === null) {
            var ref;
            setListProducts(CarouselResponse === null || CarouselResponse === void 0 ? void 0 : (ref = CarouselResponse[0]) === null || ref === void 0 ? void 0 : ref.contentsArray);
        }
    }, [
        CarouselResponse
    ]);
    var settings = {
        arrows: true,
        dots: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        centerMode: false,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsNext, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsPrev, {}),
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrow: true
                }
            },
            ,
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrow: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    };
    var renderSlides = function() {
        return ListProducts.map(function(slide, index) {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                h: "full",
                paddingLeft: "10px",
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                    w: "190px",
                    h: "390px",
                    mr: "10px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                        w: "full",
                        height: "full",
                        borderRadius: "10px"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                    justify: "center",
                    w: "190px",
                    bgColor: "ll-white.main",
                    border: "1px solid",
                    borderColor: "ll-gray.100",
                    borderRadius: "10px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "https://www.pneufree.com.br/linglong/".concat(slide.Url),
                        _hover: {
                            textDecoration: "none",
                            opacity: "0.5"
                        },
                        _focus: {
                            border: "none"
                        },
                        mb: "15px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                            position: "relative",
                            w: "full",
                            h: "390px",
                            direction: "column",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                w: "100%",
                                direction: "column",
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                                        h: "180px",
                                        marginBottom: "10px",
                                        marginTop: "5px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                            loading: "lazy",
                                            borderTopRadius: "6px",
                                            src: (0,utils/* shoppingImagePath */.ph)(slide.Img),
                                            alt: slide.Model,
                                            width: "170px",
                                            height: "170px",
                                            onError: function(e) {
                                                return e.currentTarget.src = "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/pneu-default.png";
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                        justifyContent: "center",
                                        align: "center",
                                        fontSize: "h3",
                                        color: "ll-gray.300",
                                        fontWeight: "600",
                                        letterSpacing: "-1px",
                                        children: slide.Title
                                    }),
                                    slide.Model.includes("RUN FLAT") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                        gap: "5px",
                                        w: "full",
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                align: "center",
                                                fontWeight: "500",
                                                fontSize: "text1",
                                                color: "ll-blue.main",
                                                children: slide.Model.split(" ", 1)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* Text */.x, {
                                                align: "center",
                                                fontWeight: "500",
                                                fontSize: "text1",
                                                color: "ll-red.main",
                                                children: [
                                                    " ",
                                                    "RUN FLAT"
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                        align: "center",
                                        fontWeight: "500",
                                        fontSize: "text1",
                                        color: "ll-blue.main",
                                        children: (ref1 = (ref = slide.Model) === null || ref === void 0 ? void 0 : ref.replace(slide.Title, "")) === null || ref1 === void 0 ? void 0 : ref1.replace("PNEU", "").replace("LINGLONG", "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Rating/* Rating */.iG, {
                                            number: false,
                                            generalGrade: slide.Ratings,
                                            reviewCount: slide.Reviews
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                        mt: "5px",
                                        alignItems: "center",
                                        flexDir: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                fontSize: "h1",
                                                color: "ll-blue.main",
                                                fontWeight: "500",
                                                letterSpacing: "-3px",
                                                children: (0,utils/* formatPrice */.T4)(parseFloat(slide.Price))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                                mt: "-8px",
                                                color: "ll-gray.300",
                                                fontWeight: "400",
                                                children: "\xe0 vista."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        variant: "primary-button",
                                        mt: "10px",
                                        w: "80%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                                            children: "DETALHES"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.x, {
        display: [
            "Flex",
            "none"
        ],
        flexDir: "column",
        mt: "30px",
        maxW: "1200px",
        minH: "390px",
        w: "full",
        justifyContent: "center",
        mb: "2.5rem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(center/* Center */.M, {
                mb: "15px",
                color: "ll-blue.main",
                fontSize: "h4",
                fontWeight: "500",
                letterSpacing: "2px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, settings), {
                children: ListProducts ? renderSlides() : null
            }))
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Carousel/CarouselPromoMobile.tsx











function CarouselPromoMobile() {
    var ref = (0,react.useState)(null), ListPromo = ref[0], setListPromo = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Contents/* useStoriesContents */.WA)(), 3), PromoData = ref1[0], PromoError = ref1[1], PromoLoading = ref1[2];
    (0,Custom/* useIsomorphicLayoutEffect */.LI)(function() {
        if (PromoData) {
            var ref;
            setListPromo(PromoData === null || PromoData === void 0 ? void 0 : (ref = PromoData[0]) === null || ref === void 0 ? void 0 : ref.contentsArray);
        }
    }, [
        PromoData
    ]);
    var settings = {
        arrows: false,
        dots: true,
        slidesToShow: 4,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    var renderSlides = function() {
        return ListPromo.map(function(slide, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                    justify: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: slide.Url,
                        transition: ".5s",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                            w: "full",
                            h: "auto",
                            objectFit: "contain",
                            borderRadius: "5px",
                            src: slide.Image,
                            alt: slide.Alt
                        })
                    })
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            justify: "center",
            w: "full",
            direction: "column",
            pb: "10px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, settings), {
                children: ListPromo ? renderSlides() : null
            }))
        })
    });
}

// EXTERNAL MODULE: ./src/lib/nethone-utils/Types/Overloads.ts
var Overloads = __webpack_require__(45229);
;// CONCATENATED MODULE: ./src/components/Carousel/CarouselHeaderMobile.tsx













function CarouselHeaderMobile() {
    var ArrowProductsPrev = function ArrowProductsPrev(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            cursor: "pointer",
            bgColor: "#ffffff26",
            borderRadius: "50px",
            justifyContent: "center",
            alignItems: "center",
            w: "45px",
            h: "45px",
            position: "absolute",
            left: "15%",
            top: "45%",
            zIndex: 1,
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                h: "15px",
                src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-banner.svg"
            })
        });
    };
    var ArrowProductsNext = function ArrowProductsNext(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            cursor: "pointer",
            bgColor: "#ffffff26",
            borderRadius: "50px",
            justifyContent: "center",
            alignItems: "center",
            w: "45px",
            h: "45px",
            position: "absolute",
            right: "15%",
            top: "45%",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                h: "15px",
                src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-banner.svg",
                transform: "rotate(180deg)"
            })
        });
    };
    var ref = (0,react.useState)(true), isLoading = ref[0], setLoading = ref[1];
    var IsWide = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        lg: true
    });
    var setActionIsLoading = (0,LoadingContext/* useLoading */.r$)().setActionIsLoading;
    var ref1 = (0,react.useState)([]), ListCarousel = ref1[0], setListCarousel = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,Contents/* useBannersContents */.eI)(), 3), BannersResponse = ref2[0], BannersError = ref2[1], BannersLoading = ref2[2];
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function() {
        if (BannersResponse && BannersError === null) {
            var ref;
            setListCarousel(BannersResponse === null || BannersResponse === void 0 ? void 0 : (ref = BannersResponse[0]) === null || ref === void 0 ? void 0 : ref.contentsArray);
            // setListCarousel(null);
            setLoading(false);
        }
    }, [
        BannersResponse
    ]);
    var settings = {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 4500,
        adaptiveHeight: false,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsNext, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowProductsPrev, {})
    };
    var isWideVersion = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
        display: [
            "Flex",
            "none"
        ],
        flexDir: "column",
        minH: "175px",
        mt: !isWideVersion && "70px",
        mb: "20px",
        w: "auto",
        justifyContent: "center",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
            w: "full",
            h: [
                "100px",
                "250px"
            ],
            alignItems: "center",
            justify: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                thickness: "3px",
                speed: "0.65s",
                emptyColor: "ll-green.main",
                color: "#1e1e1e",
                size: [
                    "md",
                    "xl"
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, settings), {
                children: [
                    (ListCarousel === null || ListCarousel === void 0 ? void 0 : ListCarousel.length) > 0 ? ListCarousel.map(function(slide, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                href: slide.Url,
                                onClickCapture: function() {
                                    return setActionIsLoading(true);
                                },
                                onClick: function() {
                                    router_default().push(slide.Url);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                    border: "none",
                                    mr: "10px",
                                    ml: "10px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                            marginRight: "-2px",
                                            border: "none",
                                            w: "full",
                                            h: [
                                                "90px",
                                                "auto"
                                            ],
                                            background: slide.BgLeft,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            display: [
                                                "none",
                                                "flex"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                            borderRadius: "15px",
                                            loading: index > 0 ? "lazy" : "eager",
                                            src: isWideVersion ? slide.Image : slide.MobileImage,
                                            alt: "Banner LingLong",
                                            width: [
                                                "full",
                                                "1180px"
                                            ],
                                            height: [
                                                "auto",
                                                "230px"
                                            ],
                                            onError: function(e) {
                                                return e.currentTarget.src = "https://cdn.pneufree.com.br/LingLong/images/Site/img/local/DefaultBanner.jpg";
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                            marginLeft: "-2px",
                                            border: "none",
                                            w: "full",
                                            background: slide.BgRight,
                                            alignItems: "center",
                                            display: [
                                                "none",
                                                "flex"
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, index);
                    }) : null,
                    ListCarousel === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        border: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                            border: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                    border: "none",
                                    w: "100vw",
                                    h: [
                                        "120px",
                                        "auto"
                                    ],
                                    background: "#106BBA",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image/* Image */.E, {
                                    loading: "eager",
                                    alt: "Default Banner LingLong",
                                    src: "https://cdn.pneufree.com.br/LingLong/images/Site/img/local/DefaultBanner.jpg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                    border: "none",
                                    w: "100vw",
                                    background: "#014B96",
                                    alignItems: "center"
                                })
                            ]
                        })
                    }) : null
                ]
            }))
        })
    });
}

// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var dist_aos = __webpack_require__(28279);
;// CONCATENATED MODULE: ./src/pages/index.tsx














function Home() {
    var setActionIsLoading = (0,LoadingContext/* useLoading */.r$)().setActionIsLoading;
    setActionIsLoading(false);
    var isWideVersion = (0,use_breakpoint_value/* useBreakpointValue */.S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: true
    });
    (0,react.useEffect)(function() {
        return function() {
            (0,Overloads/* InitializeNethone */.P)({
                allowedFields: [
                    "MenuEmail",
                    "FreeSearch",
                    "TireWidth",
                    "TireSeries",
                    "TireRim",
                    "BarVehicleBrand",
                    "BarVehicleModel",
                    "BarVehicleYear",
                    "MenuVehicleBrand",
                    "MenuVehicleModel",
                    "MenuVehicleYear"
                ],
                secretFields: [
                    "MenuPassword"
                ]
            });
        };
    }, []);
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsloading = ref[1];
    // --------simula o loading do skeleton--------
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setIsloading(false);
        }, 2000);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            aos_default().init({
                once: true,
                duration: 1500
            });
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* SEO */.H, {
            title: "Loja Oficial LingLong | Compre Pneus Online e Receba Super R\xe1pido.",
            description: "Promo\xe7\xf5es de pneus LingLong ✓ Menor Custo de Frete ✓ Compra Segura em at\xe9 12x.",
            path: "/",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Layout */.Ar, {
                direction: "column",
                mb: "0px",
                mt: "0",
                className: "Layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselHeader, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselHeaderMobile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {
                        loading: isLoading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarMobile, {
                        loading: isLoading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        justifyContent: "center",
                        bgColor: " #F1EEEE",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselProducts, {
                                title: "AS MELHORES OFERTAS DE PNEUS",
                                loading: isLoading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselProductsMobile, {
                                title: "AS MELHORES OFERTAS DE PNEUS",
                                loading: isLoading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        flexDir: "column",
                        bgColor: "ll-white.main",
                        py: "25px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                w: "full",
                                justifyContent: "center",
                                mb: "25px",
                                "data-aos": "fade-up",
                                "data-aos-delay": "100",
                                "data-aos-duration": "700",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                                        display: [
                                            "none",
                                            "flex"
                                        ],
                                        w: "1200px",
                                        src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/pix-desktop.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* Img */.E, {
                                        display: [
                                            "flex",
                                            "none"
                                        ],
                                        w: "95%",
                                        src: "https://cdn.pneufree.com.br/LINGLONG/images/Geral/pix-mobile.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                justifyContent: "center",
                                "data-aos": "fade-up",
                                "data-aos-delay": "100",
                                "data-aos-duration": "700",
                                children: isWideVersion ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselPromo, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselPromoMobile, {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,9214,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);